import React from 'react';
import './Hero.css';

const Hero = () => {
  const features = [
    {
      icon: '📄',
      title: 'Streamline Workflows',
      description: 'Efficient process management'
    },
    {
      icon: '👤',
      title: 'Manage Projects',
      description: 'Complete project control'
    },
    {
      icon: '⚙️',
      title: 'Optimize Operations',
      description: 'Enhanced productivity'
    }
  ];

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1 className="hero-title">One Platform. Multiple Solutions.</h1>
        <p className="hero-description">
          Transform your business operations with our comprehensive platform designed 
          to streamline workflows, manage projects, and optimize your entire operation.
        </p>
        <div className="hero-buttons">
          <button className="btn-primary">Get Started</button>
          <button className="btn-secondary">Learn More</button>
        </div>
        <div className="feature-cards">
          {features.map((feature, index) => (
            <div key={index} className={`feature-card ${index === 1 ? 'feature-card-highlight' : ''}`}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="scroll-indicator">
          <div className="scroll-arrow">↓</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
